import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { IsAuthenticatedUseCase } from '../../features/auth';
import * as S from './ProtectedRoute.styles';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  const isAuthenticatedUseCase = new IsAuthenticatedUseCase();

  useEffect(() => {
    const checkAuth = async () => {
      const auth = isAuthenticatedUseCase.execute();
      setAuthenticated(auth);
      setIsChecking(false);
    };

    checkAuth();
  }, []);

  if (isChecking) {
    return (
      <S.ProtectedRouteLoading>
        <S.ProtectedRouteSpinner>⏳</S.ProtectedRouteSpinner>
        <S.ProtectedRouteText>Проверка авторизации...</S.ProtectedRouteText>
      </S.ProtectedRouteLoading>
    );
  }

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

